<template>
    <div class="mainpage">
        <h2>print delivery note</h2>

        <div class="home noprint">
            <div v-if="!validSOprn.so" class="form">
                <div>Scan SO:</div>
                <input ref="sofld2" type="text" v-model="tmpSO" class="inp big" @keypress.enter="scanSO"/>
            </div>
            <div v-else class="c">
                <div class="flx" @click="invalidateSO">
                    <refresh-icon/>
                </div>
                SO: <b>{{ validSOprn.so }}</b>
                <span v-if="validSOprn.customerName"> | <b>{{ validSOprn.customerName }}</b></span>
            </div>
        </div>
        <div v-if="validSOprn.items" class="home" style="background-color: white">
            <img src="@/assets/tomcat_big.png" width="200" style="float:right">
            <h3>Sales Order Number: <b>{{ validSOprn.so }}</b></h3>
            <h3>Customer: <b>{{validSOprn.customerName}}</b></h3>
            <br style="clear: both">
            <blockquote v-for="(it, i ) in validSOprn.items">
                <div class="h4">
                    <div class="ic">{{i}}</div>
                    <div>shipped: {{it.totalcnt}}</div>
                    <div v-if="it.qtty && it.qtty>it.totalcnt">not yet shipped: {{it.qtty - it.totalcnt}}</div>
                    <div>{{it.itemDescr}}</div>
                </div>
                <ul>
                    <li v-for="(data, dt) in it.data">
                        <b>{{dt}}</b> - items: {{data.cnt}}
                        <ul class="nopad">
                            <li class="cust" v-if="data.sns2">{{data.sns2}}</li>
                            <li>{{data.sns}}</li>
                        </ul>
                    </li>
                </ul>
            </blockquote>
        </div>

        <div class="home" v-else-if="validSOprn.so">
            No items shipped yet.
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import Vue from 'vue'

    export default {
        name: "DeliveryNote",
        components: {
            RefreshIcon
        },
        computed: {
            ...mapState(['validSOprn', 'lastResult']),

        },
        watch: {
            lastResult: function () {
                this.$toasted.show(this.lastResult.msg, {
                    theme: "toasted-primary",
                    position: "top-center",
                    fullWidth: true,
                    duration: 3000,
                    type: this.lastResult.type
                });
            }

        },
        data() {
            return {
                tmpSO: '',
            }
        },
        mounted() {
            setTimeout(() => {
                if (this.$refs.sofld2) this.$refs.sofld2.focus();
            }, 10);
            if (this.validSO) {
                this.tmpSO = this.validSO.so;
                this.scanSO();
            }
        },
        methods: {
            invalidateSO: function () {
                this.$store.commit('setSOprndata', []);
                Vue.nextTick(() => {
                    this.$refs.sofld2.select();
                })

            },
            scanSO: function () {
                if (this.tmpSO && this.tmpSO.trim().length < 5) return;
                this.$store.dispatch('validateSOforDLV', this.tmpSO);
                this.tmpSO = '';
            },
        }
    }
</script>

<style scoped>
    .form > DIV {
        margin: 5px 7px 5px 0;
    }

    h3 {
        font-weight: normal;
        margin: 10px 0;
    }
    UL.nopad {
        padding-left: 1em;
    }
    UL.nopad LI {
        margin: 3px 0;
    }
    LI.cust {
       list-style-type: square;
    }
    .h4 {
        margin: 0;
        padding: 3px 0;
        border-bottom: solid 1px black;
        display: flex;
        justify-content: space-between;
    }
    .h4 .ic {
        font-weight: bold;
    }

    UL LI {
        margin: 10px 0;
        line-height: 1.5em;
    }

    BLOCKQUOTE {
        margin: 10px
    }

    .form {
        display: flex;
        clear: both;
        align-items: center;
    }

    .flx {
        float: right;
        font-size: 20px;
        margin: -5px -10px;
    }

    .form > DIV {
        white-space: nowrap
    }
</style>